module.exports = __webpack_public_path__ + "img/20210830_150011.5f937418.jpg";